import React from "react";
import MiniPatientCard from "./MiniPatientCard";
import { Form, Input, DatePicker, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Chatbot from "../../chat";
import Navbar from "../Navbar/Navbar";

function MyPatients() {
  return (
    <div>
      <Navbar />
      <div className="container">
        <div
          className="row"
          style={{ marginTop: "2rem", paddingLeft: 20, paddingRight: 20 }}
        >
          <Form>
            <div className="row">
              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-4" style={{ textAlign: "right" }}>
                    Patient's Name
                  </div>
                  <div className="col-md-8">
                    <Form.Item>
                      <Input
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        placeholder="Enter the patient's name"
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-4" style={{ textAlign: "right" }}>
                    Patient's DOB
                  </div>
                  <div className="col-md-8">
                    <Form.Item>
                      <DatePicker
                        style={{ width: "100%" }}
                        placeholder="Enter the Date of Birth"
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div
                className="col-md-2"
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                <Button
                  icon={<SearchOutlined />}
                  style={{
                    backgroundColor: "#9254DE",
                    color: "white",
                    fontWeight: "500",
                  }}
                >
                  Search
                </Button>
              </div>
            </div>
          </Form>
        </div>

        <div className="row">
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
        </div>
        <div className="row" style={{ marginTop: "2rem" }}>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
          <div className="col-md-3">
            <MiniPatientCard />
          </div>
        </div>
      </div>
      <Chatbot />
    </div>
  );
}

export default MyPatients;
